import { Building } from './Building';
import { Type } from 'class-transformer';
import { Location as RouterLocation } from 'vue-router';

/**
 * @package entity
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Location
 */
export class Location {
  private id!: number;

  @Type(() => Building)
  private readonly building!: Building;

  private name!: string;

  private icon!: string;

  public getId(): number {
    return this.id;
  }

  public getCompoundId(): number {
    return Number(this.getBuilding().getCompoundId().toString() + this.getId().toString());
  }

  public getName(): string {
    return this.name;
  }

  public getIcon(): string {
    return this.icon;
  }

  public getBuilding(): Building {
    return this.building;
  }

  public getRouteLocation(): RouterLocation {
    return {
      name: 'dashboard.location.accounts',
      params: {
        locationId: String(this.getId()),
      },
    };
  }
}
